module.exports = __webpack_public_path__ + "img/logo-tg-lp.afec7c13.png";